// @ts-check
/**
 * Bet builder market in place request
 */
export default class BetBuilderPlaceMarketModel {
  constructor(data, betBuilderItem, swishModel = false) {
    const bbMarket = betBuilderItem.betBuilder[data.GlobalIdLong] || {};
    /**
     * Market global long id
     * @type {string}
     */
    this.gil = swishModel ? data.globalId : data.GlobalIdLong;
    /**
     * Market global short id
     * @type {string|null}
     */
    this.gis = swishModel ? null : data.GlobalIdShort;
    /**
     * Market status
     * @type {number}
     */
    this.ls = swishModel ? 0 : data.LegStatus;

    if (!swishModel) {
      /**
       * Id of the market description
       * @type {number|null}
       */
      this.lb = swishModel ? 0 : bbMarket.labelId;
    }
    if (swishModel) {
      /**
       * Match player prop id
       * @type {number|null}
       */
      this.mpid = data.matchPlayerId ? data.matchPlayerId : null;
      /**
       * Pre-match market id
       * @type {number|null}
       */
      this.mmid = data.preMatchMarketId ? data.preMatchMarketId : null;
      /**
       * Line
       * @type {string}
       */
      this.l = data.line;
      /**
       * Line type, for SportCast items default value is null, for Swish, depends is it "over", or "under"
       * the first letter is used as a description("o"/"u")
       * @type {string}
       */
      this.lt = data.globalId.includes('over') ? 'o' : data.globalId.includes('under') ? 'u' : '';
      /**
       * Over odd
       * @type {number}
       */
      this.oo = data.globalId.includes("over") ? +data.odd : 0;
      /**
       * Under odd
       * @type {number}
       */
      this.uo = data.globalId.includes("under") ? +data.odd : 0;
      /**
       * Stats id
       * @type {number}
       */
      this.sid = data.statsId;
      /**
       * Team enum
       * @type {string}
       */
      this.t = data.team;
      /**
       * Swish player id
       * @type {number}
       */
      this.sp = data.playerId || null;
    }
  }
}
